// Wraper around <input type="text" />
import { TextReplacements } from "components/text_replacements";
import * as React from "react";
export class TextAreaInput extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.state = { text: this.props.text };
    }
    componentWillUnmount() {
        this.props.onEnd(this.props.text, this.state.text);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ text: nextProps.text });
    }
    onChange(event) {
        let value = event.target.value;
        this.setState({ text: event.target.value });
        this.props.onChange(value);
    }
    onKeyPress(event) {
        if (this.props.enableReplacements === true)
            TextReplacements.onKeyPress(this, event);
    }
    onKeyDown(event) {
        if (this.props.enableReplacements === true)
            TextReplacements.onKeyDown(this, event);
    }
    manuallySetText(newText, newCursorPosition) {
        this.setState({ text: newText }, () => this.ref.current.setSelectionRange(newCursorPosition, newCursorPosition));
        this.props.onChange(newText);
    }
    onBlur(event) {
        this.props.onEnd(this.props.text, this.state.text);
    }
    render() {
        var _a;
        return React.createElement("textarea", { value: this.state.text, rows: (_a = this.props.rows) !== null && _a !== void 0 ? _a : 8, className: "ui-input", onFocus: e => { var _a; return (_a = this.props.onFocus) === null || _a === void 0 ? void 0 : _a.call(null); }, onChange: e => this.onChange(e), onKeyPress: e => this.onKeyPress(e), onKeyDown: e => this.onKeyDown(e), onBlur: e => this.onBlur(e), ref: this.ref, placeholder: this.props.placeholder });
    }
}
